import {
  MousePointer2,
  Pencil,
  Minus,
  ArrowRight,
  Circle,
  Trash2,
} from "lucide-react";

const TOOLS = [
  { id: "none", icon: MousePointer2, label: "Select" },
  { id: "pen", icon: Pencil, label: "Pen" },
  { id: "line", icon: Minus, label: "Line" },
  { id: "arrow", icon: ArrowRight, label: "Arrow" },
  { id: "circle", icon: Circle, label: "Circle" },
];

const COLORS = ["#E4FF00", "#FF3B30", "#007AFF", "#FFFFFF"];

export default function DrawingToolbar({
  tool,
  setTool,
  color,
  setColor,
  onClear,
  hasStrokes,
  label,
  layout,
}) {
  // Vertical layout: scrubber is an overlay at bottom-0 (hover-revealed). Toolbar floats above it.
  // Horizontal layout: scrubber is a docked row (~56px) below the video area; toolbar sits above it.
  const positionClass =
    layout === "vertical" ? "bottom-16" : "bottom-[68px]";

  return (
    <div
      className={`absolute ${positionClass} left-1/2 -translate-x-1/2 z-30 opacity-0 group-hover:opacity-100 focus-within:opacity-100 hover:opacity-100 transition-opacity duration-200`}
      data-testid={`drawing-toolbar-${label}`}
    >
      <div className="flex items-center gap-1 bg-[#1A1A1A]/90 backdrop-blur-md border border-white/10 rounded-lg p-1.5 shadow-[0_8px_24px_rgba(0,0,0,0.6)]">
        {TOOLS.map((t) => {
          const Icon = t.icon;
          const active = tool === t.id;
          return (
            <button
              key={t.id}
              onClick={() => setTool(t.id)}
              className={`w-9 h-9 rounded-md flex items-center justify-center transition-all ${
                active
                  ? "bg-[#007AFF] text-white shadow-[0_0_12px_rgba(0,122,255,0.4)]"
                  : "text-white/60 hover:text-white hover:bg-white/10"
              }`}
              title={t.label}
              data-testid={`tool-${t.id}-${label}-button`}
            >
              <Icon className="w-4 h-4" />
            </button>
          );
        })}

        <div className="w-px h-6 bg-white/10 mx-1" />

        {COLORS.map((c) => (
          <button
            key={c}
            onClick={() => setColor(c)}
            className={`w-7 h-7 rounded-full border-2 transition-all ${
              color === c
                ? "border-white scale-110"
                : "border-white/20 hover:border-white/60"
            }`}
            style={{ backgroundColor: c }}
            title={`Color ${c}`}
            data-testid={`color-${c.replace("#", "")}-${label}-button`}
          />
        ))}

        <div className="w-px h-6 bg-white/10 mx-1" />

        <button
          onClick={onClear}
          disabled={!hasStrokes}
          className="w-9 h-9 rounded-md flex items-center justify-center text-white/60 hover:text-[#FF3B30] hover:bg-[#FF3B30]/10 transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
          title="Clear annotations"
          data-testid={`clear-drawings-${label}-button`}
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
